import styled, { css } from 'styled-components'
import { WHITE } from '../../utils/colors'

type ContainerProps = {
  variant?: 'facebook' | 'google'
}

export const Container = styled.button<ContainerProps>`
  cursor: pointer;
  width: 100%;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  border: none;

  .content {
    display: flex;
    align-items: center;

    .spinner {
      margin-left: 10px;

      svg {
        fill: ${WHITE};
      }
    }
  }

  .icon {
    margin-top: 5px;
    margin-right: 15px;
    img { width: 24px; }
  }

  background-color: ${props => props.variant === 'facebook' ? '#1877F2' : WHITE};
  color: ${props => props.variant === 'facebook' ? WHITE : 'rgba(0, 0, 0, 0.54)'};

  ${props => props.variant === 'google' && css`
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.084), 0px 2px 3px rgba(0, 0, 0, 0.168);

    .content .spinner svg {
      fill: rgba(0, 0, 0, 0.54);
    }
  `}

`
